<div class="bn-payment-other-policies">
    <div class="bn-mkpay-title">Make a payment</div>
    <div class="bn-panow-desc">Click “pay now” to make your policy payment.</div>
    <div class="other-bn-payment">
        <div class="bn-paynow-sec">
            <div class="bn-paynow-sec-inner">
                <div class="bn-min-amt-text">Min amount due</div>
                <div class="bn-pay-act-sec margin-bottom mb16">
                    <div class="bn-min-amt-val">
                        <ng-container *ngIf="!policy?.billingDetails || (policy?.billingDetails && currentMinAmtDue === 0)">
                            {{'$0.00'}}
                        </ng-container>
                        <ng-container *ngIf="policy?.billingDetails && policy?.billingDetails[0]?.paymentDueDate && currentMinAmtDue !== 0">
                            {{ currentMinAmtDue | currency }}                                
                            <ng-container *ngIf="policy?.billingDetails[0].amountStillDue === 0 &&  policy?.hasPriorYearBalance; else hasAmountDue">
                                <span class="bn-due-date-text" *ngIf="policy?.hasPriorYearBalance">{{ '  on ' }} {{ policy?.priorYearBalanceDueDate | customDateFormat }}  </span>
                            </ng-container>
                            <ng-template #hasAmountDue>
                                <span class="bn-due-date-text" *ngIf="!policy?.hasPriorYearBalance">{{ '  on ' }} {{ paymentDate | customDateFormat }}  </span>
                            </ng-template>
                        </ng-container>
                    </div>
                    <div>
                        <ng-container *ngIf="policy?.policynumber.policyNumber.length===10; else goToPaybill">
                        <mapfre-button 
                            [inputType]="'submit'"
                            [additionalClasses]="'basic primary bn-paynow-action-btn'"
                            [translateValue]="'Pay now'"
                            (click)="payNow(policy?.policynumber?.policyNumber, policy?.mailingAddress?.zipCode?.code, policy?.billingDetails[0]?.amountStillDue)"   
                        >
                        </mapfre-button>
                    </ng-container>
                        <ng-template #goToPaybill>              
                            <form ngNoForm method="POST" target="_blank" [action]="getPayBillLink(policy)">
                                <input class="hides" type="text" name="txtMiscellaneous" [value]="onCreatePaymentForm(policy?.policynumber?.policyNumber,policy?.mailingAddress?.zipCode?.code, policy?.billingDetails[0]?.amountStillDue, policy?.format, policy?.company)">
                                <input class="hides" type="text" name="txtAcctNumber" *ngIf="getPayBillSource(policy)!==''" [value]="getCheckDigits(policy?.policynumber?.policyNumber,policy?.checkDigits, policy?.company.companyName, policy?.mailingAddress?.zipCode?.code, policy?.format)">
                                <input class="hides" type="text" name="txtSource" [value]="getPayBillSource(policy)">
                                <input type="submit" class="btn mapfre basic primary bn-paynow-action-btn" value="Pay now">
                              </form>
                          </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
